// qrCodeApi.js
import api from './api'; // Import your base Axios instance

const QrCodeApi = {
  // Create a new QR code log; expects a QrCodeRequest object and returns a Call<Long>
  create: (qrCodeRequest) => {
    return api.post("qr-code", qrCodeRequest);
  },

  // Update an existing QR code log; expects a QrCodeRequest object and returns a Call<Void>
  update: (qrCodeRequest) => {
    return api.put("qr-code", qrCodeRequest);
  }
};

export default QrCodeApi;
